<template> 
  <v-tabs v-if="titles.length > 1 && !active_tab_conditional" class="tabs" slider-color="white" :value.sync="active">
    <v-tab :class="dark_t ? 'vtabs_dark':'vtabs'" v-for="(title, i) in titles" :key="i" @click="go(i)">
      <fs1-span :class="b(i)">{{title}}</fs1-span>
    </v-tab>
    <v-tabs-items touchless v-model="staticActive">
      <v-tab-item>
        <v-card :class="'cardTab'">
          <slot></slot>
          <router-view v-if="can_access"></router-view>
          <div v-else>Sin permisos o cargandolos</div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
  <v-card :class="'cardTab'" v-else class="background-color-1">
    <slot></slot>
    <router-view v-if="can_access" :key="$route.fullPath"></router-view>
    <div v-else>Sin permisos o cargandolos</div>
  </v-card>
</template>
<script>
import View from '@/views/View.js';

export default {
  props: ['id'],
  mixins: [View],
};
</script>
